let User;
if (gon.user)
  User = {
    admin: gon.tadmin,
    viewer: !gon.tadmin,
    checker: gon.checker,
    operator: gon.operator || gon.tadmin,
    me: gon.user.id === 1,
    leagues_admin: gon.user.id <= 2 || gon.user.id === 2811,
    leagues_operator: gon.user.global_role === "leagues_operator" || gon.user.global_role === "admin" || gon.tadmin,
  }
else
  User = {
    viewer: true
  }

export default User;